export default __webpack_public_path__ + "static/media/google.07c492e4.svg";